<template>
  <div class="body-panel sku">
    <div class="body-panel-control separator">
      <div class="control-block-left">
        <div class="flex mob-inline">
          <project-select @onChange="onProjectChange" :user="info.User" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
          <div class="form-field margin-right-20">
            <drop-down class=""
                       :items="statuses"
                       :dataField="'Id'"
                       :textField="'Name'"
                       v-model="statusId"
                       @change="onStatusChange($event)"></drop-down>
          </div>
          <div class="form-field margin-right-20">
            <drop-down class=""
                       :items="dateTypes"
                       :dataField="'Id'"
                       :textField="'Name'"
                       v-model="dateTypeId"
                       @change="onStatusChange($event)"></drop-down>
          </div>
          <div class="form-field flex mob-inline">
            <input-date name="dateStart" v-model="dateStart" @input="onDateChange" class="input-text input-date" todayHighlight="true"></input-date>
            <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
            <input-date name="dateEnd" v-model="dateEnd" @input="onDateChange" class="input-text input-date" todayHighlight="true"></input-date>
          </div>
          <div class="form-field margin-left-20" v-if="statusId || dateStart || dateEnd || dateTypeId">
            <button type="button" class="btn" @click="clearFilterState">Сбросить</button>
          </div>
        </div>
      </div>
      <div class="control-block-right btns flex">
        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                           class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />
        <div style="margin: auto 10px;" v-if="selectedAnswers.length">
          Выбрано {{ selectedAnswers.length }} из {{ totalCount }}
        </div>
        <button class="btn" @click="onExportReport()" v-if="projectId === currentProjectIds.Opus && (hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)) && answers.length > 0">
          Отчет
        </button>
        <button class="btn" @click="onExportAnalytics()" v-if="projectId === currentProjectIds.Cersanit && (hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)) && answers.length > 0">
          Аналитика
        </button>
        <button class="btn" @click="onGeneralExport()" v-if="(hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)) && answers.length > 0">
          Общая выгрузка
        </button>
        <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()" v-if="(hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit))">
          Смена Статуса
        </button>
        <button class="btn" @click="onExport()" v-if="(hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)) && answers.length > 0">
          Экспорт
        </button>
        <button type="button" class="btn btn-primary" @click="updateMultipleAnswerStatuses(2, '')" v-if="selectedAnswers.length">Принять</button>
        <button type="button" class="btn btn-delete" @click="btnReject(4)" v-if="selectedAnswers.length">Доработать</button>
        <button type="button" class="btn btn-delete" @click="btnReject(5)" v-if="selectedAnswers.length">Отклонить</button>
        <button type="button" class="btn" @click="selectedCancel()" v-if="selectedAnswers.length">Отмена</button>
        <button type="button" class="btn btn-delete" @click="removeAnswers()" v-if="selectedAnswers.length">Удалить</button>

      </div>
      <div class="body-panel-control-separator">
        <complex-filter ref="complexFilter"
                        :cacheKey="'reportsComplexFilter'"
                        :filters="filteredUserFilters"
                        :searchFunction="searchFunction"
                        :tableName="'[dbo].[AspNetUsers]'"
                        @onFilterChange="onFilterChange"
                        :withTableNameInClause="true"></complex-filter>
      </div>
    </div>
    <div class="body-panel-content body-panel-content-page" @scroll="onScroll">
      <table class="table-view" id="dataTable">
        <thead class="head-show">
        <tr class="heading">
          <th class="check" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">
            <input id="selectAll" name="selectAll" value="true" type="checkbox" class="input-checkbox"
                   v-model="selectAll" @change="onSelectAllChange($event)" />
            <label for="selectAll" class="input-checkbox-lbl"></label>
          </th>
          <th>Id</th>
          <th>Задание</th>
          <th>Пользователь</th>
          <th>Статус</th>
          <th>Заполнение</th>
          <th>Изменение статуса</th>
          <th>Окончание задания</th>
          <th>Состояние задания</th>
          <th v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">Кто последний поменял статус</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) of answers" @click.stop="openAnswerTest(item.TasksId, item.Id, item.LastStatus)">
          <td class="check" @click.stop="" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">
            <input :id="'select' + i" :value="item" type="checkbox" class="input-checkbox" v-model="selectedAnswers" @change="onCheckChange(item)" />
            <label :for="'select' + i" class="input-checkbox-lbl"></label>
          </td>
          <td class="id">{{item.Id}}</td>
          <td class="string">{{item.TaskName}}</td>
          <td class="date-range">{{ item.User.Fio }}</td>
          <td :class="['state', getStateClass(item)]">{{ item.LastStatusFormatted }}</td>
          <td class="date">{{ item.FillingDate | date-short }}</td>
          <td class="date">{{ item.DateStatus | date-short }}</td>
          <td class="date">{{ item.TaskEndDate | date-short }}</td>
          <td class="value-center">{{ item.TaskActive ? 'Активно' : 'Завершено' }}</td>
          <td class="date-range" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">{{ item.LastActionUser.Fio }}</td>
          <td class="value-center">
            <button type="button" class="btn" @click.stop="openAnswerTest(item.TasksId, item.Id, item.LastStatus)" title="Открыть">Открыть</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <popup-window ref="ppActionModal" :title="'Обработка ответов'" :modal="true">
      <div class="form-group">
        <p v-if="!actionState.done">
          Ответ {{actionState.currentAnswer.index}} / {{actionState.total}} от {{formatDate(actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm')}} в процессе {{actionState.currentAnswer.time}} сек.
        </p>
        <p v-else>
          <template v-if="actionState.doneMessage">
            {{actionState.doneMessage}}
          </template>
          <template v-else>
            Обработка завершена
          </template>
        </p>
        <div class="margin-top-20" style="max-height:300px;overflow:auto;">
          <p v-for="m of actionState.messages" :style="m.error ? 'color:red': ''" class="caption-help">
            {{m.message}}
          </p>
        </div>
      </div>
      <div class="btns flex margin-top-20" data-toggle="buttons">
        <button type="button" class="btn" @click="ppActionModalClose" v-if="actionState.done || actionState.test">Закрыть</button>
      </div>

    </popup-window>

    <popup-window ref="ppComment" :title="popuptitle" :width="800">
      <div class="">
        <div class="form-field">
          <label class="input-text-lbl"> </label>
          <textarea rows="10"
                    :name="'SettingsDescription'"
                    :class="['input-memo', {'input-error': errors.has('SettingsDescription', 'edition')}]"
                    v-model="commentStatus"
                    v-validate="'required'"
                    data-vv-scope="edition"></textarea>
          <span class="field-validation-valid" v-if="errors.has('SettingsDescription', 'edition')">Заполните поле</span>
        </div>
        <div class="btns flex margin-top-20 margin-bottom-20">
          <button type="button" class="btn" @click="tryChangeStatus()">Принять</button>
          <button type="button" class="btn" @click.stop="closeModal('ppComment')">Отмена</button>
        </div>
      </div>
    </popup-window>

    <popup-window ref="ppConfirmDelete" :title="'Подтверждение удаления'" :modal="true">
      <div class="form-group">
        <p>Вы уверены, что хотите удалить {{ selectedAnswers.length }} {{ getAnswerWord(selectedAnswers.length) }}?</p>
        <div class="btns flex margin-top-20" data-toggle="buttons">
          <button type="button" class="btn btn-danger" @click="confirmDeleteAnswers">Да</button>
          <button type="button" class="btn" @click="cancelDelete">Нет</button>
        </div>
      </div>
    </popup-window>

    <vue-headful :title="getPageTitle()" />
  </div>
</template>

<script>
import $ from 'jquery'
import UI from '../helpers/ui-helpers'
import BackendApi from '../backendApi'
import projectMixin from '../helpers/project-mixin'
import _ from 'lodash'
import moment from 'moment'
import {TaskAnswerStates as AnswerStateCode, TaskAnswerStates} from "../enums";
import { ProjectIds } from "../enums";
import config from "../config";

let backendApi = new BackendApi();
let cacheKey = 'answers';
let DateTypes = {
  /* Дата заполнения */
  FillingDate: 1,
  /* Дата отчета */
  ReportDate: 2,
  /* Дата изменения статуса */
  StatusDate: 3
};

let processFilter = function (filter) {
  let resultFilter = JSON.parse(JSON.stringify(filter));
  if (resultFilter) {
    for (let item of resultFilter) {
      let filterField = item[0];
      if (filterField === '[dbo].[AspNetUsers].[t.Name]') {
        item[0] = 't.[Name]';
      }
      if(filterField === '[dbo].[AspNetUsers].[ta.Id]') {
        item[0] = 'ta.[Id]';
        item[2] = item[2].replace(new RegExp('\'', 'g'), '');
      }
    }
  }
  return resultFilter;
};

export default {
  name: "tasks",

  props: ['info'],

  mixins: [projectMixin], // projectId

  data() {
    return {
      answers: [],
      rowsPerPage: 20,
      projectId: null,
      search: null,
      active: true,
      importResult: null,
      groups: [],
      groupsOrigin: null,
      lastGroupId: null,
      firstLoad: true,
      emptyResults: false,
      statusId: 0,
      dateTypeId: DateTypes.FillingDate,
      dateStart: null,
      dateEnd: null,
      statuses: [
        { Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' },
        { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' },
      ],
      dateTypes: [
        { Id: DateTypes.FillingDate, Name: ' Дата заполнения' },
        { Id: DateTypes.ReportDate, Name: 'Дата изменения ответа' },
        { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }
      ],
      page: 1,
      canBeLoaded: true,
      loading: false,
      scrollTop: null,
      filter: null,
      userFilters: [
        { Value: 'LastName', Name: 'Фамилия' },
        { Value: 'FirstName', Name: 'Имя' },
        { Value: 'MiddleName', Name: 'Отчество' },
        { Value: 't.Name', Name: 'Задание' },
        { Value: 'ta.Id', Name: 'Id ответа' }
      ],
      selectAll: false,
      selectedAnswers: [],
      totalCount: 0,
      actionState: {
        currentAnswer: {
          index: 0,
          date: null,
          time: 0
        },
        total: 0,
        messages: [],
        done: false
      },
      popuptitle: 'Причина отправки на доработку',
      commentStatus: '',
      selectStatus: 0,
      currentProjectIds: ProjectIds[config.mode]
    }
  },

  computed: {
    filteredUserFilters() {
      let vm = this;
      if(vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) || vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)) {
        return this.userFilters;
      } else {
        return this.userFilters.filter(f => !['LastName', 'FirstName', 'MiddleName'].includes(f.Value));
      }
    }
  },

  watch: {
    '$route.query.folderId'(to, from) {
      this.reload();
    }
  },

  methods: {

    getStateClass(item) {
      return 'task-state-' + item.LastStatus;
    },

    openAnswerTest(taskId,answerId, status) {
      let vm = this;

      if(vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) || vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit))
        this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/checking');
      else if (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
        if (status === AnswerStateCode.OnEdition)
          this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/edit');
        else
          this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/view');
      }
    },

    onStatusChange() {
      this.reload();
      this.saveFilterState();
    },

    onDateChange() {
      this.reload();
      this.saveFilterState();
    },

    onProjectChange(item) {
      let vm = this;

      vm.filter = null;
      vm.$refs['complexFilter'].clear();

      vm.projectId = item.Id;
      vm.statusId = '';
      vm.dateTypeId = DateTypes.FillingDate;
      vm.dateStart = '';
      vm.dateEnd = '';
      vm.scrollTop = null;
      vm.saveFilterState();

      //vm.loadSettings().then(function () {
      //    vm.reload();

      //    vm.$emit('user-updated');
      //});
    },

    reload() {
      this.page = 1;
      this.answers = [];
      this.loading = false;
      this.canBeLoaded = true;
      this.selectedAnswers = [];
      this.loadNext();
    },

    loadNext() {
      let vm = this;
      this.loading = true;
      UI.blockUI('.dataContent', 'Загрузка...');
      let skip = (vm.page - 1) * vm.rowsPerPage;
      let take = vm.rowsPerPage;
      if (vm.firstLoad && vm.page > 1) {
        skip = 0;
        take = vm.page * vm.rowsPerPage;
      }
      let timeZone = new Date().getTimezoneOffset();
      let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
      let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
      //vm.projectId = parseInt(this.$route.params.id);
      let filterFormatted = '';
      let author = null;
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(x => { return JSON.stringify(x) });
        //filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(x => { return JSON.stringify(x) });
        //console.log('filterFormatted', filterFormatted);
      }
      if(!vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) && !vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)){
        author = vm.info.User.Id;
      }

      //console.info('info.ProjectsLength', this.info.ProjectsLength, skip, take, vm.page, vm.rowsPerPage, filterFormatted);
      //vm.CommonMixin_UsersProcessFilter(vm.filter)
      this.callApiWrapper(backendApi.tasksAnswers(skip, take, vm.projectId, 0, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted, author))
          .then(function (resp) {
            if (resp.hasError && resp.status === 401) {
              this.$router.push('/projects')
            }
            else if (resp.hasError) {
              UI.toastr.error('Ошибка во время загрузки заданий');
            }
            else {
              if (resp.data.list && resp.data.list.length) {
                vm.answers.push(...resp.data.list);
                vm.totalCount = resp.data.totalCount;

                console.info('[vm.firstLoad, vm.scrollTop]', [vm.firstLoad, vm.scrollTop])
                if (vm.firstLoad) {
                  vm.firstLoad = false;
                  if (vm.scrollTop) {
                    $('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500, () => {
                      // перезаписываем значение после анимации, чтобы не было скролла при перезагрузке
                      vm.scrollTop = 0;
                      vm.saveFilterState();
                    });
                  }
                }
              }
              else {
                vm.canBeLoaded = false;
              }
            }
            UI.unblockUI('.dataContent');
            vm.loading = false;
          })
          .catch(function (err) {
            console.info('err', err)
            UI.toastr.error('Ошибка во время загрузки');
          })
    },

    onExport() {
      let vm = this;

      let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
      let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();

      let filterFormatted = '';
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(x => { return JSON.stringify(x) });
      }

      if (vm.selectedAnswers.length > 0) {
        if (!filterFormatted) {
          filterFormatted = [];
        }
        let ids = _.map(vm.selectedAnswers, function (item) {
          return item.Id;
        });
        filterFormatted.push(['ta.[Id]', 'IN', '(' + ids.join(';') + ')']);
      }

      UI.blockUI('#app');
      this.callApiWrapper(backendApi.tasksExport(vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted))
          .then(function (resp) {
            if (resp.hasError && resp.status !== 401) {
              UI.toastr.error('Ошибка во время экспорта');
              console.info('resp', resp);
            }
            else {
              let exportFile = resp.data;
              if (exportFile != null) {
                UI.downloadFileByBytes(exportFile, "Задания.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
              }
            }
            UI.unblockUI('#app');
          });
    },

    onGeneralExport() {
      let vm = this;

      let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
      let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();

      let filterFormatted = '';
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(x => { return JSON.stringify(x) });
      }

      if (vm.selectedAnswers.length > 0) {
        if (!filterFormatted) {
          filterFormatted = [];
        }
        let ids = _.map(vm.selectedAnswers, function (item) {
          return item.Id;
        });
        filterFormatted.push(['ta.[Id]', 'IN', '(' + ids.join(';') + ')']);
      }

      UI.blockUI('#app');
      this.callApiWrapper(backendApi.tasksGeneralExport(vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted))
          .then(function (resp) {
            if (resp.hasError && resp.status !== 401) {
              UI.toastr.error('Ошибка во время экспорта');
              console.info('resp', resp);
            }
            else {
              let exportFile = resp.data;
              if (exportFile != null) {
                UI.downloadFileByBytes(exportFile, "Общая выгрузка.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
              }
            }
            UI.unblockUI('#app');
          });
    },

    onFileChange(){
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let projectId = this.$route.params.projectId;
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/tasks/update-status',
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    vm.importResult = resp.result;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.page = 1;
                                    vm.users = [];
                                    vm.loadNext();
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error('Ошибка на сервере');
                                console.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

    onExportReport() {
      UI.blockUI('#app');
      this.callApiWrapper(backendApi.tasksExportReport())
          .then(function (resp) {
            if (resp.hasError && resp.status !== 401) {
              UI.toastr.error('Ошибка во время экспорта');
              console.info('resp', resp);
            }
            else {
              let exportFile = resp.data;
              if (exportFile != null) {
                UI.downloadFileByBytes(exportFile, "Отчет.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
              }
            }
            UI.unblockUI('#app');
          });
    },

    onExportAnalytics() {
      UI.blockUI('#app');
      this.callApiWrapper(backendApi.tasksExportAnalytics())
          .then(function (resp) {
            if (resp.hasError && resp.status !== 401) {
              UI.toastr.error('Ошибка во время экспорта');
              console.info('resp', resp);
            }
            else {
              let exportFile = resp.data;
              if (exportFile != null) {
                UI.downloadFileByBytes(exportFile, "Аналитика.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
              }
            }
            UI.unblockUI('#app');
          });
    },

    clearFilterState() {
      this.dateStart = '';
      this.dateEnd = '';
      this.statusId = '';
      this.dateTypeId = DateTypes.FillingDate;

      localStorage.removeItem(cacheKey);
      this.reload();
    },

    saveFilterState() {
      console.info('this.statusId:', this.statusId);

      let stateObj = {
        statusId: this.statusId,
        dateTypeId: this.dateTypeId,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        projectId: this.projectId,
        page: this.page,
        scrollTop: this.scrollTop
      };
      localStorage.setItem(cacheKey, JSON.stringify(stateObj));
    },

    recoverFilterState() {
      let stateObj = JSON.parse(localStorage.getItem(cacheKey));
      console.info('recoverFilterState -> stateObj:', stateObj);
      if (stateObj) {
        if (stateObj.statusId != null) {
          this.statusId = stateObj.statusId;
        }
        if (stateObj.dateTypeId) {
          this.dateTypeId = stateObj.dateTypeId;
        }
        if (stateObj.dateStart) {
          this.dateStart = stateObj.dateStart;
        }
        if (stateObj.dateEnd) {
          this.dateEnd = stateObj.dateEnd;
        }
        if (stateObj.projectId == this.projectId) {
          if (stateObj.page) {
            this.page = stateObj.page;
          }
          if (stateObj.scrollTop) {
            this.scrollTop = stateObj.scrollTop;
          }
        }
      }

    },

    onScroll(e) {
      let vm = this;
      if (!vm.loading && vm.canBeLoaded) {
        let elem = $(e.target);
        vm.scrollTop = elem.scrollTop();
        if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
          vm.page++;
          vm.loadNext();
        }
      }
    },

    searchFunction(tableName, columnName, search, filters, searchPage, callback) {
      let vm = this;
      let filterFormatted = '';
      if (filters) {
        //filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(x => { return JSON.stringify(x) });
        filterFormatted = processFilter(filters).map(x => { return JSON.stringify(x) });
      }

      if(!vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) && !vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)){
        filterFormatted = processFilter([["[dbo].[AspNetUsers].[Id]", "IN", `('${vm.info.User.Id}')`]]).map(x => { return JSON.stringify(x) });
      }

      this.callApiWrapper(backendApi.tasksDistinctValues(columnName, this.projectId, 0, search, filterFormatted,
          (searchPage - 1) * 30, 30))
          .then(function (resp) {
            callback(resp.data);
          })
    },

    onFilterChange(filter) {
      this.filter = filter;
      this.answers = [];
      this.loading = false;
      this.canBeLoaded = true;
      this.page = 1;

      this.loadNext();
    },

    onSelectAllChange(e) {
      let vm = this;

      vm.selectedAnswers = [];
      if (vm.selectAll) {
        for (let answer of vm.answers) {
          vm.selectedAnswers.push(answer);
        }
      }
    },

    onCheckChange(item) {
      let vm = this;
      if (vm.selectedAnswers.filter(x => x == item).length === 0) {
        vm.selectAll = false;
      } else if (vm.selectedAnswers.length === vm.answers.length) {
        vm.selectAll = true;
      }
    },

    selectedCancel() {
      this.selectAll = false;
      this.selectedAnswers = [];
    },

    ppActionModalClose() {
      this.closeModal('ppActionModal');
      this.reload();
    },

    btnReject(state) {
      let vm = this;
      vm.selectStatus = state;
      vm.commentStatus = '';

      if (state === 4)
        vm.popuptitle = 'Причина отправки на доработку';
      else
        vm.popuptitle = 'Причина отклонения';
      vm.$refs['ppComment'].show();
    },

    removeAnswers() {
      let vm = this;
      vm.showConfirmDeleteModal();
    },

    showConfirmDeleteModal() {
      this.$refs.ppConfirmDelete.show();
    },

    async confirmDeleteAnswers() {
      let vm = this;
      await vm.updateMultipleAnswerStatuses(TaskAnswerStates.Remove, '');
      vm.closeModal('ppConfirmDelete');
    },

    cancelDelete() {
      this.$refs.ppConfirmDelete.hide();
    },

    tryChangeStatus() {
      let vm = this;
      vm.closeModal('ppComment');
      this.updateMultipleAnswerStatuses(vm.selectStatus, vm.commentStatus)
    },

    getAnswerWord(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return 'ответ';
      } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
        return 'ответа';
      } else {
        return 'ответов';
      }
    },

    updateMultipleAnswerStatuses(status, comment) {
      let vm = this;
      if (vm.selectedAnswers.length === 0)
        return;

      let statusLabel;
      switch (status) {
        case TaskAnswerStates.Accepted:
          statusLabel = "Принято";
          break;
        case TaskAnswerStates.OnEdition:
          statusLabel = "Отправлено на доработку";
          break;
        case TaskAnswerStates.Rejected:
          statusLabel = "Отклонено";
          break;
        case TaskAnswerStates.Remove:
          statusLabel = "Удалено";
          break;
        default:
          statusLabel = "Неизвестный статус";
          break;
      }

      let selectedAnswers = this.selectedAnswers.map(x => {
        return {
          Id: x.Id,
          TaskId: x.TaskId,
          Status: status,
          EditionComment: comment,
          Date: x.DateStatus,
        }
      });

      vm.actionState = {
        currentAnswer: {
          index: 0,
          date: null,
          time: 0
        },
        total: 0,
        messages: [],
        done: false
      };

      vm.$refs.ppActionModal.show();

      (async function loop() {
        UI.blockUI('dataContent', 'Обработка');

        let secondsInterval;
        vm.actionState.total = selectedAnswers.length;
        for (let answer of selectedAnswers) {
          vm.actionState.currentAnswer.index++;
          vm.actionState.currentAnswer.time = 0;
          vm.actionState.currentAnswer.date = answer.Date;

          secondsInterval = setInterval(function () {
            vm.actionState.currentAnswer.time += 1;
          }, 1000);
          await vm.callApiWrapper(backendApi.tasksAnswerAccept(answer.TaskId, answer.Id, answer.Status, answer.EditionComment))

              .then(function (response) {
                clearInterval(secondsInterval);

                let answerTitle = `Ответ ${vm.actionState.currentAnswer.index} от ${vm.formatDate(vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm')}`;

                if(response.hasError) {
                  switch(response.status) {
                    case 722:
                      vm.actionState.messages.push({
                        message: `${answerTitle}: Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены`,
                        error: true
                      });
                      break;
                    case 723:
                      vm.actionState.messages.push({
                        message: `${answerTitle}: Отклонить можно только тот ответ, по которому бонусы не были истрачены`,
                        error: true
                      });
                      break;
                    case 724:
                      vm.actionState.messages.push({
                        message: `${answerTitle}: Удалить можно только тот ответ, по которому бонусы не были истрачены`,
                        error: true
                      });
                      break;
                    default:
                      vm.actionState.messages.push({
                        message: `${answerTitle}: Ошибка при сохранении`,
                        error: true
                      });
                      break;
                  }
                } else {
                  vm.actionState.messages.push({message: `${answerTitle}: ${statusLabel}`});
                }
                if (vm.actionState.currentAnswer.index === vm.actionState.total) {
                  vm.actionState.done = true;
                  UI.unblockUI('dataContent');
                }
              });
        }
      })();
    },
  },

  mounted() {
    let vm = this;

    vm.recoverFilterState();

    //Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
    //    vm.loadNext();
    //});
    vm.loadNext();
    //UI.blockUI('.dataContent', 'Загрузка...');
    //vm.loadNext().then(() => {
    //    UI.unblockUI('.dataContent');
    //});

    vm.$nextTick(() => {

      $('.body-panel-content').on('scroll', function () {
        let elem = $(this);
        let scrollTop = elem.scrollTop();
        vm.scrollTop = scrollTop;

        if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
          //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
          if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
            vm.page++;
            vm.loadNext();
          }
        }
      });
    });
  },

  destroyed() {
    $('.body-panel-content').off('scroll');
  }
}
</script>


// WEBPACK FOOTER //
// Content/src/views/TasksTable.vue